import { Pipe, PipeTransform } from "@angular/core";


/// <summary>
/// Duration time take number of (mseconds = ms or seconds = s or minutes = m or hours = h)
/// it convert them to one of the following formats
/// Seconds = s
/// Minutes = m
/// Hours = h 
/// HH:MM = HH:MM
/// Days = D
/// DateTime Object = Date
///
/// Input Format {{ value | DurationTime:'Input - Output'}}
/// Default Input seconds
/// Default Output Minutes
///</summary>
@Pipe({ name: 'DurationTime' })
export class DurationTimePipe implements PipeTransform{
    transform(value: number, args: string){
        let InputFormat = 's';
        let OutputFormat = 'm';
        if(args){
            var _args = args.toLowerCase().split('-');
            if(_args.length == 2){
                InputFormat = _args[0].trim();
                OutputFormat = _args[1].trim();
            }
            else{
                InputFormat = 's';
                OutputFormat = _args[0];
            }
        }
        // convert the input of any type into seconds if seconds Ignore
        let Seconds: number = value;
        if (Seconds < 0) {
            let DefaultDuration;
            switch (OutputFormat.toLowerCase()) {
                case 'hh:mm':
                    DefaultDuration = '00:00';
                    break;
                case 'date':
                    DefaultDuration = new Date().toISOString();
                    break;
                default:
                    DefaultDuration = '0';
                    break;
            }
            return DefaultDuration;
        }
        if(InputFormat != 's'){
            switch(InputFormat){
                case 'ms':
                    Seconds = value / 1000;
                    break;
                case 'm':
                    Seconds = value * 60;
                    break;
                case 'h':
                    Seconds = value * 3600;
                    break;
                default:
                    Seconds = value;
                    break;
            }
        }

        // convert seconds into the output format
        let Duration = '';
        switch(OutputFormat.toLowerCase()){
            case 's':
                Duration = Seconds.toString();
                break;
            case 'm':
                Duration = (Seconds / 60).toFixed(2).toString();
                break;
            case 'h':
                Duration = (Seconds / 3600).toFixed(2).toString(); 
                break;
            case 'hh:mm':
                let Hours = Math.floor(Seconds / 3600); 
                let RemainSeconds = Seconds % 3600;
                let Minutes = Math.floor(RemainSeconds / 60);
                if(Hours / 24 > 1){
                    let Days = Math.floor(Hours / 24);
                    Hours = Math.floor(Hours % 24);
                    Duration = Days.toString() + 'd ' + ('0' + Hours.toString()).slice(-2) + ':' + ('0' + Minutes.toString()).slice(-2);                    
                }
                else{
                    Duration = ('0' + Hours.toString()).slice(-2) + ':' + ('0' + Minutes.toString()).slice(-2);
                }
                break;
            case 'd':
                Duration = (Seconds / 86400).toFixed(2).toString();
                break;
            case 'date':
                let date = new Date(+Seconds)
                Duration = date.toISOString();
                break;
            default:
                Duration = (Seconds / 60).toString(); 
                break;
        }

        return Duration;

    }
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/pipes/duration-time.pipe.ts